import { render } from "./modal-dettaglio-ticket.vue?vue&type=template&id=6723db78&scoped=true"
import script from "./modal-dettaglio-ticket.vue?vue&type=script&lang=js"
export * from "./modal-dettaglio-ticket.vue?vue&type=script&lang=js"

import "./modal-dettaglio-ticket.vue?vue&type=style&index=0&id=6723db78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6723db78"]])

export default __exports__